import io from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
// const URL = `https://api.krafo.com`; //live
const URL = `https://apidwmdev.appgrowthcompany.com`; //dev

export const socket = io(URL, {
  autoConnect: false,
});
